import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const UpdateSectionDivision = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()

    const initialFormState = {
        sectionMasterId: sectionMasterId,
        instituteMasterId: instituteMasterId,
        year: '',
        gradeId: '',
        divisionId: '',
        newDivisionId: ''
    }
    const initialUpdateForm = {
        divisionId: null,
        studentIds: []
    }

    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [filteredDivisionList, setFilteredDivisionList] = useState([])
    const [yearList, setYearList] = useState([])
    const [importStudentData, setImportStudentData] = useState(initialFormState)
    const [studentDivision, setStudentDivision] = useState(initialUpdateForm)
    const [importStudentList, setImportStudentList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [studentIdSort, setStudentIdSort] = useState(null);
    const [regIdSort, setRegIdSort] = useState(null);
    const [nameSort, setNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["std_id", "regis_no", "studentName", "primaryContact"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList()
        getYearList()
    }, []);

    useEffect(() => {
        getStudentList();
    }, [importStudentData]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getStudentList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (importStudentData.year !== '') {
                setImportStudentList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim(), "rows"))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(importStudentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(importStudentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > importStudentList.length) {
            endIndex = importStudentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(importStudentList.slice(startIndex, endIndex));
    }, [importStudentList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = '/students?';
        if (importStudentData.sectionMasterId !== '') {
            apiUrl += `sectionMasterId=${importStudentData.sectionMasterId}&`;
        }
        if (importStudentData.instituteMasterId !== '') {
            apiUrl += `instituteMasterId=${importStudentData.instituteMasterId}&`;
        }
        if (importStudentData.year !== '') {
            apiUrl += `year=${importStudentData.year}&`;
        }
        if (importStudentData.gradeId !== '') {
            apiUrl += `gradeId=${importStudentData.gradeId}&`;
        }
        if (importStudentData.divisionId !== '') {
            apiUrl += `divisionId=${importStudentData.divisionId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getStudentList = () => {
        if (importStudentData.year !== '') {
            authorizedAxiosSection && authorizedAxiosSection.get(getApiUrl())
                .then(response => {
                    setImportStudentList(response.data.result.rows);
                })
                .catch(error => {
                    setImportStudentList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setImportStudentData((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: value,
            };

            if (name !== "newDivisionId") {
                updatedData.newDivisionId = '';
            }

            return updatedData;
        });
    }

    const handleGradeChange = (e) => {
        setImportStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                divisionId: '',
                newDivisionId: '',
            }
        })

        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    useEffect(() => {
        const filteredLIst = importStudentData.divisionId.length > 0
            ? divisionList.filter(division => division.id != importStudentData.divisionId)
            : [];
        setFilteredDivisionList(filteredLIst);
    }, [importStudentData])

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(importStudentData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(importStudentData)) {
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }

    }, [importStudentData])

    const handleSelectAllClick = (students) => {
        setStudentDivision((prevState) => {
            const allSelected = students.length === prevState.studentIds.length;
            return {
                ...prevState,
                studentIds: allSelected ? [] : students.map(student => student.id)
            };
        });
    };

    const handleCheckboxClick = (studentId) => {
        setStudentDivision((prevState) => {
            const studentIds = prevState.studentIds.includes(studentId)
                ? prevState.studentIds.filter(id => id !== studentId)
                : [...prevState.studentIds, studentId];
            return {
                ...prevState,
                studentIds
            };
        });
    };

    const updateStudentDivision = async () => {
        const apiUrl = `/migrate-students`;

        if (validateForm()) {
            setLoading(true);
            const data = {
                divisionId: importStudentData.newDivisionId,
                studentIds: studentDivision.studentIds
            };

            try {
                const response = await authorizedAxiosSection.post(apiUrl, data);
                getStudentList();
                setStudentDivision(initialUpdateForm);

                setStudentIdSort(null);
                setRegIdSort(null);
                setNameSort(null);

                Swal.fire({ text: response.data.message });
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false); // End loading
            }
        } else {
            for (const [key, value] of Object.entries(importStudentData)) {
                setError((prevData) => ({
                    ...prevData,
                    [key]: value === '' || value.length === 0 ? 'This field is required.' : ''
                }));
            }
        }
    };


    const handleReset = () => {
        setDivisionList([]);
        setImportStudentList([]);
        setImportStudentData(initialFormState);
        setStudentDivision(initialUpdateForm);
        setError(initialErrorState);

        setStudentIdSort(null);
        setRegIdSort(null);
        setNameSort(null);
    }


    useEffect(() => {
        if (studentIdSort == true || studentIdSort == false) {
            setRegIdSort(null);
            setNameSort(null);
        }
    }, [studentIdSort])

    useEffect(() => {
        if (regIdSort == true || regIdSort == false) {
            setStudentIdSort(null);
            setNameSort(null);
        }
    }, [regIdSort])

    useEffect(() => {
        if (nameSort == true || nameSort == false) {
            setStudentIdSort(null);
            setRegIdSort(null);
        }
    }, [nameSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Update Division</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-pen-nib"></i>Update Division</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='year' onChange={handleInputChange} value={importStudentData.year}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            yearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.year && <p style={{ color: 'red' }}>{error.year}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="gradeId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='gradeId' onChange={handleGradeChange} value={importStudentData.gradeId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.gradeId && <p style={{ color: 'red' }}>{error.gradeId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='divisionId' onChange={handleInputChange} value={importStudentData.divisionId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.divisionId && <p style={{ color: 'red' }}>{error.divisionId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="newDivisionId" className="col-form-label"><span style={{ color: "red" }}>*</span>New Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='newDivisionId' disabled={studentDivision.studentIds.length === 0} onChange={handleInputChange} value={importStudentData.newDivisionId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            filteredDivisionList.map((division) => (
                                                                <option key={division.id} value={division.id}>
                                                                    {division.divisionName}
                                                                </option>
                                                            ))
                                                        }
                                                    </select>
                                                    {error.newDivisionId && <p style={{ color: 'red' }}>{error.newDivisionId}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={updateStudentDivision}>Migrate</button>
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleReset}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        {importStudentList?.length > 0 && <th>
                                                                            <input
                                                                                type='checkbox'
                                                                                checked={studentDivision.studentIds.length === importStudentList?.length}
                                                                                onClick={() => handleSelectAllClick(importStudentList)}
                                                                            /> All
                                                                        </th>}
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Std Id
                                                                            <SortIcon sortState={studentIdSort} setSortState={setStudentIdSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"std_id"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Reg Id
                                                                            <SortIcon sortState={regIdSort} setSortState={setRegIdSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"regis_no"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Name
                                                                            <SortIcon sortState={nameSort} setSortState={setNameSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"studentName"} />
                                                                        </th>
                                                                        <th scope="col">Phone No</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th>
                                                                                            <input
                                                                                                type='checkbox'
                                                                                                checked={studentDivision.studentIds.includes(std.id)}
                                                                                                onClick={() => handleCheckboxClick(std.id)}
                                                                                            />
                                                                                        </th>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{std.std_id}</td>
                                                                                        <td>{std.regis_no}</td>
                                                                                        <td>{std.studentName}</td>
                                                                                        <td>{std.primaryContact}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Students Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={importStudentList.length} />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default UpdateSectionDivision;
